import { render } from "./Footer.vue?vue&type=template&id=f582cf9e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=f582cf9e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\natan\\OneDrive\\Code\\Site\\dalena\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f582cf9e"]])

export default __exports__